// ============================================================
// A fixed hash in [0, 1) of two numbers - the plate's jitter, a falling
// drop's next place, a servo's next set. Stateless, so a frame can ask for
// any value at any time; never Math.random (gotcha 5). The display's seeded
// rng (engine/display/rng) is sequential, which per-frame sampling cannot use.
//
// Pure. Zero React dependency.
// ============================================================

import { scatterOf } from '../battlefield/terrainAnimation';

export function hash01(a: number, b: number): number {
  const v = Math.sin(a * 12.9898 + b * 78.233) * 43758.5453;
  return v - Math.floor(v);
}

/**
 * Numbers in [0, 1) drawn from a seed (an impact's id, a hit's moment): the same on every screen and every replay,
 * any salt any time. FNV over the seed and salt (battlefield/terrainAnimation's `scatterOf`).
 */
export const seeded =
  (seed: string) =>
  (salt: string | number): number =>
    scatterOf(`${seed}:${salt}`);
